module.exports = __webpack_public_path__ + "8bfb3287af0e5f0bb8deb9a5c640529a.png";